module.exports = __webpack_public_path__ + "static/media/React-icon.c7d21855.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/React-icon.svg
// module id = 51
// module chunks = 0